// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_DETAIL_LINKED_OBJECTS_COUNSELLING = "Z poradne";
export const STROLLER_DETAIL_LINKED_OBJECTS_DISCUSSION = "Diskusia";
export const STROLLER_DETAIL_LINKED_OBJECTS_EXPAND = "V\u0161etky ot\u00e1zky";
export const STROLLERS_COUNSELLING = "Ko\u010d\u00edkov\u00e1 porad\u0148a";
